import { usePaginatedApi, useDetailApi } from "../../../swr/useApi";
import { adminChangeRequestsService } from "../../api_client";
import type {
  ChangeRequestDto,
  DocumentsQueryDto,
  UserChangeRequestsDto,
} from "../../../api";

export function useAdminChangeRequests(query?: DocumentsQueryDto) {
  return usePaginatedApi<ChangeRequestDto, DocumentsQueryDto>({
    key: "admin-change-requests",
    serviceMethod: async (queryParams) =>
      await adminChangeRequestsService.adminListChangeRequests(queryParams),
    query,
  });
}

export function useAdminChangeRequestsGroupedByUser(query?: DocumentsQueryDto) {
  return usePaginatedApi<UserChangeRequestsDto, DocumentsQueryDto>({
    key: "admin-change-requests-grouped-by-user",
    serviceMethod: async (queryParams) =>
      await adminChangeRequestsService.findAllGroupedByUser(queryParams),
    query,
  });
}

export function useAdminChangeRequestDetails(id: string | undefined) {
  return useDetailApi<ChangeRequestDto>({
    key: id ? `admin-change-request-details-${id}` : null,
    serviceMethod: async () =>
      await adminChangeRequestsService.adminGetChangeRequest(id!),
  });
}
